import { render, staticRenderFns } from "./UpdateOrderDetails.vue?vue&type=template&id=ed877dd6&scoped=true&"
import script from "./UpdateOrderDetails.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOrderDetails.vue?vue&type=style&index=0&id=ed877dd6&scoped=true&lang=css&"
import style1 from "./UpdateOrderDetails.vue?vue&type=style&index=1&id=ed877dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed877dd6",
  null
  
)

export default component.exports